import styled from 'styled-components';

export const PrivateRouteWrapper = styled.div<{ isMenuOpen: boolean, isRemoteControl: boolean, path?: string }>(
  ({ isMenuOpen, isRemoteControl, path }) => `
  padding: ${isRemoteControl ? '0px' : '24px 16px'};
  @media (min-width: 768px) {
    padding-top: 70px;
    padding-left: ${isMenuOpen ? '270px' : '75px'};
    padding-right: 20px;
  }

  ${handlePaddingOverview(isMenuOpen, path)}
`,
);

function handlePaddingOverview(isMenuOpen: boolean, path?: string): string {
  if (path !== '/nova-visao-geral') return '';

  const paddingLeft = isMenuOpen ? '260' : '70';

  return `
    padding: 0px;

    @media (min-width: 768px) {
      padding: 0px;
      padding-top: 70px;
      padding-left: ${paddingLeft}px;
    }

    @media (max-width: 768px) {
      padding-top: 20px;
    }
  `;
}
